import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  PARTNER: {
    id: 'Partner.partner',
    defaultMessage: 'Partner',
    description: '[Type: Label][Vis.: low] - Partner link in main navigation',
  },
});

const Partner = () => {
  const url = createURL('https://www.surveymonkey.com/mp/partner-program/', {
    ut_source: 'header',
  });
  const title = t(COPY.PARTNER);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.PARTNER} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.PARTNER} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default Partner;
export { Partner };
